// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { RemoteAssistanceOperatorAreaId } from './RemoteAssistanceOperatorAreaId'
import {
  RemoteAssistanceOperatorAreaNavigation,
  RemoteAssistanceOperatorAreaNavigationIcon,
} from './RemoteAssistanceOperatorAreaNavigation'
import { RemoteAssistanceOperatorAreaRoutes } from './RemoteAssistanceOperatorAreaRoutes'

const LazyRemoteAssistanceOperatorComponent = lazy(
  () => import('./RemoteAssistanceOperatorArea'),
)

const RemoteAssistanceOperatorComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRemoteAssistanceOperatorComponent />
  </SuspenseLoadingWrapper>
)

export const RemoteAssistanceOperatorArea = {
  id: RemoteAssistanceOperatorAreaId,
  requiredRight: BoumRight.AREA_REMOTE_ASSISTANCE_OPERATOR,
  Icon: RemoteAssistanceOperatorAreaNavigationIcon,
  NavigationComponent: RemoteAssistanceOperatorAreaNavigation,
  route: {
    path: RemoteAssistanceOperatorAreaRoutes.route,
    component: RemoteAssistanceOperatorComponent,
  },
}
